import { Component, ErrorInfo, ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

import {
  ErrorDisplay,
  ErrorDisplayProps,
} from '@/common/components/error-display/ErrorDisplay.tsx';

interface Props extends ErrorDisplayProps {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      const defaultActions = (
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={() => window.location.reload()}
        >
          <Trans>Reload page</Trans>
        </Button>
      );

      return (
        <ErrorDisplay
          title={this.props.title}
          message={this.props.message ?? this.state.error?.message}
          actions={this.props.actions ?? defaultActions}
          sx={this.props.sx}
        />
      );
    }

    return this.props.children;
  }
}
